import type { Currency, TierDiscountConfiguration } from '@weft/types';
import { DISCOUNT_TYPES } from '@weft/types';
import { isNotNullOrUndefined, raiseUnreachable } from '@weft/utils';
import { formatNumber } from '@weft/utils';
import type { HTMLFormInputElement } from 'apps/app/src/components/design/Input/Input';
import { Price } from 'apps/app/src/components/design/Price';
import { getCurrencySymbol } from 'apps/app/src/services/currency-symbol-mapper';
import { getEmptyCellContent } from 'apps/app/src/services/table/get-empty-cell-content';
import cn from 'classnames';
import { useState } from 'react';
import { Input } from '../../../../../components/design/Input';
import { CheckIcon } from '../../../../../components/icons/CheckIcon';
import { DiscountFormContainer } from './DiscountFormContainer';
const ENTER_KEY = 'Enter';

type DiscountCellProps = {
  discount: TierDiscountConfiguration | undefined;
  lineItemId: string;
  productVariantId: string;
  other?: any;
  tierIndex: number;
  currency: Currency
  disabled?: boolean;
};

export const DiscountCell: React.FC<DiscountCellProps> = ({ disabled = false, discount, lineItemId, productVariantId, tierIndex, currency }) => {
  const [editMode, setEditMode] = useState(false);

  const preventEnterSubmit = (event: React.KeyboardEvent<HTMLFormInputElement<any>>) => {
    if (event.key === ENTER_KEY) {
      event.preventDefault();
    }
  };

  if (disabled) {
    return isNotNullOrUndefined(discount) ? <Price currency={currency}>{discount?.amount}</Price> : <>{getEmptyCellContent()}</>;
  }

  return (
    <DiscountFormContainer
      tierIndex={tierIndex}
      editMode={editMode}
      lineItemId={lineItemId}
      productVariantId={productVariantId}
      amount={discount?.amount}
    >
      {(discountRegister) => (
        <Input
          {...discountRegister}
          disabled={disabled}
          wrapperClassName="group rounded-2xl"
          className={cn('mt-0.5 flex rounded-2xl text-center duration-0',
            editMode ? 'p-2 pr-8 group-hover:border-0 py-0.5' : 'text-transparent border border-white')}
          editMode
          prefixClassName="text-black pl-1 group-hover:border-icon group-hover:border rounded-2xl w-[calc(100%-22px)]"
          editIconClassName="fill-icon duration-0"
          suffixWrapperClassName="right-2"
          autoComplete="off"
          onKeyDown={preventEnterSubmit}
          onEditModeChange={setEditMode}
          prefix={editMode ? undefined : discount ? `${getDiscountSymbol(discount, currency)}${formatNumber(discount.amount)}` : '--'}
          suffix={editMode && (
            <button
              type="submit"
              className={cn('rounded-2xl bg-white p-1 shadow-md')}
            >
              <CheckIcon color='#9EC3E4'/>
            </button>
          )
          }
        />
      )}
    </DiscountFormContainer>
  );
};

function getDiscountSymbol(discount: TierDiscountConfiguration, currency: Currency) {
  switch (discount.type) {
    case DISCOUNT_TYPES.Fixed:
      return getCurrencySymbol(currency);
    case DISCOUNT_TYPES.Percentage:
      return '%';
    default:
      return raiseUnreachable(discount.type);
  }
}